import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/publish']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const publishQuestionnaireTemplate = async ({
  creatorId,
  questionnaireTemplateId,
  ...body
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/publish', {
    creatorId,
    questionnaireTemplateId,
  });
  const data = await formsBackendClient.post(path, body);
  return data.data;
};

export default publishQuestionnaireTemplate;
